<template>
  <div class="todo-pagination">
    <el-row>
      <el-col :span="2" class="todo-pagination-total">
        Total: <strong>{{ total }}</strong>
      </el-col>
      <el-col :span="20">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: {
      total: Number,
      pageSize: Number
    },

    methods: {
      currentChange(page) {
        this.$emit('current-change', page)
      }
    }
  }
</script>

<style lang="scss">
  .todo-pagination {
    //position: absolute;
    //bottom: 0;
    //right: 0;
    //left: 0;

    .todo-pagination-total {
      padding-top: 7px;
      font-size: 14px;
      min-width: 70px;
    }
  }
</style>
